import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fd09557"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-modal__content" }
const _hoisted_2 = { class: "info-modal__title" }
const _hoisted_3 = { class: "info-modal__message" }
const _hoisted_4 = { class: "jurisdiction-selection__info" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "jurisdiction-selection__name" }
const _hoisted_7 = ["src", "alt"]

import { type PropType, ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { ModalVariant } from '@exchange/libs/modals/src';
import CryptoInfoRest from '@exchange/libs/rest-api/crypto-info-api';
import PersonalRest from '@exchange/libs/rest-api/personal-api';
import PublicRest from '@exchange/libs/rest-api/public-api';

interface Jurisdiction {
  code: string;
  name: string;
  noFiatTransfers?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmJurisdictionModal',
  props: {
  variant: { type: String as PropType<ModalVariant>, required: true },
  transactionType: { type: String as PropType<'deposit' | 'withdraw'>, required: true },
},
  emits: ["action-clicked"],
  setup(__props, { emit: __emit }) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const jurisdictions = ref<Record<string, Jurisdiction>>({});
const selectedJurisdiction = ref<Jurisdiction | null>(null);

const emit = __emit;

const jurisdictionOptions = computed(() =>
  Object.entries(jurisdictions.value).map(([code, data]) => ({
    code,
    name: data.name,
    ...data,
  })),
);

onMounted(async () => {
  jurisdictions.value = await PublicRest.Jurisdictions.get();

  try {
    const geoInfo = await CryptoInfoRest.GeoInfo.get();
    const userCountry = geoInfo.isoCode;
    const matchingJurisdiction = jurisdictionOptions.value.find((j) => j.code.toLowerCase() === userCountry.toLowerCase());

    if (matchingJurisdiction) {
      selectedJurisdiction.value = matchingJurisdiction;
    }
  } catch (error) {
    // console.error('Failed to fetch geo location:', error);
  }
});

const handleActionClick = async () => {
  if (selectedJurisdiction.value) {
    try {
      await PersonalRest.Identity.update({
        addressOfResidency: {
          country: selectedJurisdiction.value.code,
        },
      });
      emit('action-clicked', selectedJurisdiction.value.code);
    } catch (error) {
      // console.error('Failed to update jurisdiction:', error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_x_list_item = _resolveComponent("x-list-item")!
  const _component_ot_select = _resolveComponent("ot-select")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "info-modal",
    "footer-variant": "centered",
    "can-close": false,
    variant: __props.variant
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(`modules.transactions.withdraw.confirmJurisdictionModal.title`)), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.transactionType === 'withdraw'
              ? _ctx.$t(`modules.transactions.withdraw.confirmJurisdictionModal.withdrawMessage`)
              : _ctx.$t(`modules.transactions.withdraw.confirmJurisdictionModal.depositMessage`)), 1),
        _createVNode(_component_ot_select, {
          class: "info-modal__jurisdiction-select",
          value: selectedJurisdiction.value,
          options: jurisdictionOptions.value,
          label: "name",
          "track-by": "code",
          searchable: true,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (selectedJurisdiction.value = $event))
        }, {
          "selected-option": _withCtx((selected) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: `https://flagcdn.com/${selected.code.toLowerCase()}.svg`,
                alt: `${selected.name} flag`,
                class: "jurisdiction-flag"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, _toDisplayString(selected.name), 1)
            ])
          ]),
          option: _withCtx((option) => [
            _createVNode(_component_x_list_item, {
              name: `jurisdiction-option-${option.code}`,
              active: selectedJurisdiction.value?.code === option.code,
              title: option.name
            }, {
              prefix: _withCtx(() => [
                _createElementVNode("img", {
                  src: `https://flagcdn.com/${option.code.toLowerCase()}.svg`,
                  alt: `${option.name} flag`,
                  class: "jurisdiction-flag"
                }, null, 8, _hoisted_7)
              ]),
              _: 2
            }, 1032, ["name", "active", "title"])
          ]),
          _: 1
        }, 8, ["value", "options"])
      ])
    ]),
    buttons: _withCtx(({ itemClass }) => [
      _createVNode(_component_x_button, {
        class: _normalizeClass(["info-modal__action", itemClass]),
        variant: "primary",
        disabled: !selectedJurisdiction.value,
        text: _ctx.$t('modules.transactions.withdraw.confirmJurisdictionModal.action'),
        onClick: handleActionClick
      }, null, 8, ["disabled", "text", "class"])
    ]),
    _: 1
  }, 8, ["variant"]))
}
}

})